import errorMessages from "utils/validation/errorMessages";
import { phoneRequiredSchema, select2RequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { object, number } from 'yup';

const schoolFormSchema = object().shape({
	division_id: select2RequiredSchema,
	name: stringRequiredSchema,
	location: stringRequiredSchema,
	contact_first_name: stringRequiredSchema,
	contact_last_name:stringRequiredSchema,
	contact_title: stringRequiredSchema,
	email: stringRequiredSchema,
	phone_number: phoneRequiredSchema,
	description: stringOptionalSchema,
	status: stringRequiredSchema,
});

export default schoolFormSchema;